"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UserSearchSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M13,9 C14.6568542,9 16,10.3431458 16,12 C16,12.6478836 15.7946246,13.2477991 15.4454251,13.7381953 L16.8535534,15.1464466 C17.0488155,15.3417088 17.0488155,15.6582912 16.8535534,15.8535534 C16.679987,16.0271197 16.4105626,16.0464049 16.2156945,15.9114088 L16.1464466,15.8535534 L14.7381953,14.4454251 C14.2477991,14.7946246 13.6478836,15 13,15 C11.3431458,15 10,13.6568542 10,12 C10,10.3431458 11.3431458,9 13,9 Z M9,3 C10.6568542,3 12,4.34314575 12,6 C12,6.89068124 11.6118504,7.69070528 10.9954753,8.24014804 L11.0003716,8.56453937 L11,9 L10,9 L10,7.73243561 C10.5978014,7.38662619 11,6.74028236 11,6 C11,4.8954305 10.1045695,4 9,4 C7.8954305,4 7,4.8954305 7,6 C7,6.74028236 7.40219863,7.38662619 8,7.73243561 L8,9.12601749 C6.27477279,9.57006028 5,11.1361606 5,13 L5,14 L9,14 L9,15 L5,15 C4.44771525,15 4,14.5522847 4,14 L4,13 C4,10.8948158 5.30102603,9.09350251 7.14289226,8.35624595 C6.44680015,7.80685854 6,6.95560715 6,6 C6,4.34314575 7.34314575,3 9,3 Z M13,10 C11.8954305,10 11,10.8954305 11,12 C11,13.1045695 11.8954305,14 13,14 C14.1045695,14 15,13.1045695 15,12 C15,10.8954305 14.1045695,10 13,10 Z" })));
};
UserSearchSmall.displayName = 'UserSearchSmall';
exports.default = UserSearchSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UserSearchSmall.js.map